<!--
 * @Date: 2019-12-09 10:24:56
 * @LastEditors  : guantingting
 * @LastEditTime : 2019-12-19 10:57:06
 -->
<template lang="html">
  <div class="serview-evaluate">
    <div class="title">服务评价</div>
    <div class="evaluate">
      <div class="name">专业度</div>
      <div class="star">
        <star
          size="bigger"
          v-on:clickStar="getProfessionLevel"
          color="#ffc600"
          :canClick="true"
          :score="professionLevel"
        />
      </div>
      <div class="level-desc">{{ serveDesc(professionLevel) }}</div>
    </div>
    <div class="evaluate">
      <div class="name">服务效果</div>
      <div class="star">
        <star
          size="bigger"
          v-on:clickStar="getServiceLevel"
          color="#ffc600"
          :canClick="true"
          :score="serviceLevel"
        />
      </div>
      <div class="level-desc">{{ serveDesc(serviceLevel) }}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import star from '@/components/common/star'

export default {
  components: {
    star
  },
  data() {
    return {
      professionLevel: 10,
      serviceLevel: 10,
      levelDesc: []
    }
  },
  async created() {
    const descs = await this.$store.dispatch('getReasons')
    this.levelDesc = descs.data.serveStarDesc || []
  },
  methods: {
    getProfessionLevel(index) {
      this.professionLevel = index
      this.$store.commit('setNewComment', {
        specialty: index
      })
    },
    getServiceLevel(index) {
      this.serviceLevel = index
      this.$store.commit('setNewComment', {
        effect: index
      })
    },
    serveDesc(level) {
      if (this.levelDesc && this.levelDesc[level / 2 - 1]) {
        return `${this.levelDesc[level / 2 - 1]}`
      }
      return ''
    }
  },
  computed: {
    ...mapState(['newComment'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/mixin';
.serview-evaluate {
  margin-top: rem(60px);
  .title {
    margin-bottom: rem(10px);
  }
  .evaluate {
    height: rem(80px);
    display: flex;
    align-items: center;
    padding-top: rem(30px);
    padding-bottom: rem(30px);

    .name {
      padding-top: rem(5px);
      font-size: rem(28px);
      padding-right: rem(41px);
      width: rem(160px);
      text-align: right;
    }
    .level-desc {
      flex: 1;
      text-align: right;
      font-size: rem(28px);
      color: #666;
    }

    .star {
      line-height: 1;
    }
  }
}
</style>
